import { render } from "./ConfigurationVariantSpecification.vue?vue&type=template&id=4dceed22"
import script from "./ConfigurationVariantSpecification.vue?vue&type=script&lang=js"
export * from "./ConfigurationVariantSpecification.vue?vue&type=script&lang=js"

import "./ConfigurationVariantSpecification.vue?vue&type=style&index=0&id=4dceed22&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__